import { InjectionToken } from '@angular/core';
import { IAccountApiRepository } from '../repositories/account-api.repository';

export const ACCOUNT_API_REPOSITORY = new InjectionToken<IAccountApiRepository>(
  'ACCOUNT_API_REPOSITORY'
);
